import createReactClass from 'create-react-class';
import path from 'path';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { upperFirst } from 'lodash';

import BrowserCompatibilityModal from './browser_compatibility_modal';
import Err from 'models/err';
import Input from 'components/common/input';
import ErrorDisplayMixin from 'components/lib/error_display_mixin';
import { isInvalidHost, isNotAllowedWithSSO } from 'components/user/auth_errors';
import LabelInput from 'components/lib/label_input';
import Link from 'components/common/link';
import ProgressBar from 'components/common/progress_bar';
import UserButton from './lib/user_button';

const GLADLY_URL = 'https://gladly.ai';

const UserLogin = createReactClass({
  mixins: [ErrorDisplayMixin],

  propTypes: {
    errors: PropTypes.arrayOf(PropTypes.instanceOf(Err)).isRequired,
    isResponsePending: PropTypes.bool,
    isLoginPending: PropTypes.bool,
    requestedUrl: PropTypes.string,
    onForgotPassword: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
  },

  getInitialState() {
    return { email: '', password: '' };
  },

  setFieldValue(field, value) {
    this.markAsModified(field);
    this.setState({ [field]: value });
  },

  onForgotPassword() {
    this.props.onForgotPassword(this.state.email);
  },

  onLogin(ev) {
    ev.preventDefault();
    this.resetModified();
    this.props.onLogin(this.state.email, this.state.password);
  },

  render() {
    return (
      <LoginPageContainer>
        <ProgressBar isVisible={!!this.props.isResponsePending || !!this.props.isLoginPending} />
        <FormContainer className="userAuthLayout-formContainer userLogin-layout userLogin-loginLayout">
          <BrowserCompatibilityModal />
          <div className="userAuthLayout-loginForm login-form">
            <div className="userAuthLayout-loginForm-logo" />
            <div className="userAuthLayout-loginMessage">
              <p>Not all heroes wear capes.</p>
              <p>Some wear headsets.</p>
            </div>
            {this.renderFormContent()}
          </div>
        </FormContainer>
        <LoginFooter>
          <FooterLinksContainer>
            <FooterLink href={`${GLADLY_URL}/terms-of-service/`} rel="noopener noreferrer" target="_blank">
              Terms of Service
            </FooterLink>
            <FooterLink href={`${GLADLY_URL}/privacy-policy/`} rel="noopener noreferrer" target="_blank">
              Privacy Policy
            </FooterLink>
            <FooterLink href={`${GLADLY_URL}/acceptable-use-policy/`} rel="noopener noreferrer" target="_blank">
              Acceptable Use Policy
            </FooterLink>
            <FooterLink href={`${GLADLY_URL}/security-agreement/`} rel="noopener noreferrer" target="_blank">
              Security Agreement
            </FooterLink>
            <FooterLink href="https://trust.gladly.com/" rel="noopener noreferrer" target="_blank">
              Compliance
            </FooterLink>
          </FooterLinksContainer>
          <CopyrightText>© 2025 Gladly Software, Inc. All Rights Reserved.</CopyrightText>
        </LoginFooter>
      </LoginPageContainer>
    );
  },

  renderAuthorizationErrors(errors) {
    let errorMessages = null;
    let nonAttrErrors = errors.filter(err => !err.attr);
    if (nonAttrErrors.length > 0 && this.state.showErrors) {
      errorMessages = this.renderErrorMessages(nonAttrErrors);
    }
    return <div className="userAuthLayout-error">{errorMessages}</div>;
  },

  renderErrorMessages(errors) {
    return errors.map((err, index) => {
      let errorString = err.detail;
      return <span key={`error-${index}`}>{upperFirst(errorString)}</span>;
    });
  },

  renderEmail() {
    return (
      <LabelInput
        errorString={this.getErrorText('username', 'email')}
        inputId="email"
        labelClass="userAuthLayout-form-inputLabel"
      >
        <Input
          autoFocus
          className="userAuthLayout-form-input email-control"
          name="email"
          onChange={evt => this.setFieldValue('email', evt.target.value)}
          placeholder="Email"
          required="required"
          value={this.state.email}
        />
      </LabelInput>
    );
  },

  renderFormContent() {
    const errors = this.props.errors;

    if (errors?.length) {
      const err = errors[0];

      if (isNotAllowedWithSSO(err)) {
        const gladlyUrl = err.meta?.gladlyUrl;
        const relUrl = this.props.requestedUrl;
        const loginUrl = (gladlyUrl && relUrl && normalizeURL(gladlyUrl + relUrl)) || gladlyUrl || relUrl || '/';

        return (
          <form action={loginUrl} className="form-group" key="form">
            <StandaloneError data-aid="userAuthLayout-form-error" key="error-message">
              Single sign-on is required for your organization.
            </StandaloneError>
            <UserButton data-aid="userAuthLayout-form-loginButton" key="button">
              Use Single Sign-On
            </UserButton>
          </form>
        );
      } else if (isInvalidHost(err)) {
        return (
          <form action={err.meta?.gladlyUrl ?? '/'} className="form-group" key="form">
            <StandaloneError data-aid="userAuthLayout-form-error" key="error-message">
              Your organization's login page has a different address within Gladly. If you landed here using a bookmark,
              please update it after clicking the button below.
            </StandaloneError>
            <UserButton autofocus data-aid="userAuthLayout-form-loginButton" key="button">
              Open Login Page
            </UserButton>
          </form>
        );
      }
    }

    return (
      <form onSubmit={this.onLogin}>
        {this.renderAuthorizationErrors(errors)}
        {this.renderEmail()}
        {this.renderPassword()}
        {this.renderLoginButton()}
      </form>
    );
  },

  renderPassword() {
    return (
      <div className="passwordContainer">
        <LabelInput
          errorString={this.getErrorText('password')}
          inputId="password"
          labelClass="userAuthLayout-form-inputLabel"
        >
          <input
            autoComplete="off"
            className="userAuthLayout-form-input password-control"
            onChange={evt => this.setFieldValue('password', evt.target.value)}
            placeholder="Password"
            required="required"
            type="password"
            value={this.state.password}
          />
        </LabelInput>
        <Link className="forgotPassword-Link" id="forgot-password" onClick={this.onForgotPassword}>
          Forgot?
        </Link>
      </div>
    );
  },

  renderLoginButton() {
    return (
      <div className="form-group">
        <UserButton
          data-aid="userAuthLayout-form-loginButton"
          disabled={this.props.isResponsePending || this.props.isLoginPending}
          onClick={this.onLogin}
        >
          LOGIN
        </UserButton>
      </div>
    );
  },
});

function normalizeURL(urlStr) {
  const parsed = URL.parse(urlStr);
  if (!parsed) {
    return null;
  }

  parsed.pathname = path.join(parsed.pathname);

  return parsed.toString();
}

const LoginPageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const FormContainer = styled.div`
  flex: 1;
`;

const StandaloneError = styled.div`
  background-color: ${p => p.theme.colors.red100};
  border: ${p => p.theme.borderRadius.xsmall} solid ${p => p.theme.colors.red300};
  border-radius: ${p => p.theme.borderRadius.small};
  margin-bottom: 20px;
  margin-top: 25px;
  width: 450px;
  padding: 15px;
  text-align: center;
`;

const LoginFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #fff;
  padding: 10px;
  margin-top: auto;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 100vw;
  position: relative;
`;

const FooterLinksContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const FooterLink = styled.a`
  color: ${p => p.theme.colors.white};
  font-size: 12px;
  &:hover {
    color: ${p => p.theme.colors.white};
    text-decoration: underline;
  }
`;

const CopyrightText = styled.div`
  color: #fff;
  white-space: nowrap;
`;

export default UserLogin;
